import type { TextPropView } from '@consta/uikit/Text'
import cn from 'classnames'
import type { ComponentProps, FC, PropsWithChildren } from 'react'

import css from './SettingContainer.css'
import { SettingLabel } from './SettingLabel'

type SettingContainerProps = ComponentProps<'div'> & {
  size?: 'xs' | 's' | 'm' | 'l'
  label?: string
  className?: string
  view?: TextPropView
}

export const SettingContainer: FC<PropsWithChildren<SettingContainerProps>> = ({
  label,
  size = 'xs',
  children,
  className,
  view,
  ...rest
}) => {
  return (
    <div className={cn(css.settingsContainer, className)} {...rest}>
      <SettingLabel text={label} size={size} view={view} />
      {children}
    </div>
  )
}
